(function () {
  var urlParam    = 'sp';
  var storageKey  = 'dx';
  var cookieDays  = 30;
  var readyClass  = 'dx-ready';
  var retries     = 0;
  var maxRetries  = 6;
  var validValues = ['1', '2', '3', '4', '5']; // add more values here if you add more variants

  var variants = {
    '1': {
      toggles: {
        heading:      true,
        subheading:   true,
        ratingCaption:true,
        bodyText:     true,
        reviews:      true,
        accordion:    true,
        images: {
          socialProof: false,
          statement:   false,
          after:       false,
          survey:      false,
          directions:  false,
          moneyBack:   false
        }
      },
      copy: {
        heading:       'brain food',
        subheading:    'reclaim your clarity',
        ratingCaption: '4.7 rated by 836 customers',
        text:          'Feel clearer and settle into steadier focus.<br><br>A daily blend of 16 nutrients and botanicals to support clearer thinking and steady energy.',
        reviews: [
  { reviewer: 'Vicki T. (35-44)', date: '9th May 2025', stars: 5, text: '"My brain fog has lifted and I am just able to function as a human again... I just feel like I\'m not wading through mud anymore."' },
  { reviewer: 'Diana H. (45-54)', date: '11th Apr 2026', stars: 5, text: '"I am really impressed with get dopa; my focus, concentration and sleep have all improved noticeably. Best of all, it has calmed down the awful restlessness and agitation that the H in **** causes me."' },
  { reviewer: 'Adelle R. (35-44)', date: '5th Sep 2024', stars: 5, text: '"I\'m finding it easier to do all those little tasks that stack up into a big pile of overwhelm (for example: I put clean laundry away, straight away, where it belongs, not on a random chair to rot for a month!)"' },
  { reviewer: 'Fleur B. (44-54)', date: '1st Sep 2025', stars: 5, text: '"Oh my goodness me - I\'ve been taking get dopa for a few weeks and it\'s made a noticeable difference. During perimenopause I\'d been struggling with brain fog, overwhelm and fluctuating moods. Now I feel calmer, clearer and much more able to get through the day."' },
  { reviewer: 'Sarah G. (45-54)', date: '13th Jul 2025', stars: 5, text: '"get dopa has helped me get from head in hands task paralysis, to far less overwhelm and being able to tackle jobs one at a time."' }
],
        accordion: {
  matchHeading: "for brains that don’t switch off",
  newHeading:   'for brains that don’t switch off',
  newContent:   '<p>You\'re not scatty. You\'re not failing. You\'re the one who remembers the packed lunch, the permission slip, and the meeting you didn\'t have time to prepare for — all before 9am. That\'s not a lack of focus. That\'s a brain doing more than most people ever see.</p><p>Built from lived experience, alongside a team of science-led experts — because unique brains need better fuel. A thoughtfully formulated blend of nutrients and botanicals, designed to support focus, energy, and a calmer, steadier mood.</p><p>Read what our many customers have to say, and feel like the version of yourself you already know is in there — patient, present, and finally back in the room.</p>'
        },
        // Slot indices are gallery positions and are identical for every variant —
        // only the URLs change. The two pages number their slides differently, so
        // each role carries its own index and URL per page. Leave a src empty to
        // let that page keep its theme image.
        images: {
          socialProof: {
            alt:     '',
            product: { slide: 1, src: '' },
            landing: { slide: 0, src: '' }
          },
          statement: {
            alt:     '',
            product: { slide: 2, src: '' },
            landing: { slide: 1, src: '' }
          },
          after: {
            alt:     '',
            product: { slide: 6, src: '' },
            landing: { slide: 5, src: '' }
          },
          survey: {
            alt:     '',
            product: { slide: 7, src: '' },
            landing: { slide: 6, src: '' }
          },
          directions: {
            alt:     '',
            product: { slide: 8, src: '' },
            landing: { slide: 3, src: '' }
          },
          moneyBack: {
            alt:     '',
            product: { slide: 9, src: '' },
            landing: { slide: 8, src: '' }
          }
        }
      }
    },

    '2': {
      toggles: {
        heading:      false,
        subheading:   false,
        ratingCaption:true,
        bodyText:     false,
        reviews:      true,
        accordion:    false,
        images: {
          socialProof: false,
          statement:   false,
          after:       false,
          survey:      false,
          directions:  false,
          moneyBack:   false
        }
      },
      copy: {
        heading:       'your variant 2 heading',
        subheading:    '',
        ratingCaption: '4.7 rated by 836 busy brains',
        text:          'Variant 2 body text goes here.',
        reviews: [
  { reviewer: 'Diana H. (45-54)', date: '11th Apr 2026', stars: 5, text: '"I am really impressed with get dopa; my focus, concentration and sleep have all improved noticeably. Best of all, it has calmed down the awful restlessness and agitation that the H in **** causes me."' },
  { reviewer: 'Ciara J. (35-44)', date: '29th Sep 2025', stars: 5, text: '"It feels like the noise in my brain is finally quiet enough to actually get stuff done."' },
  { reviewer: 'Rhiannon K. (25-34)', date: '14th Apr 2025', stars: 5, text: '"I certainly find my challenges with **** more manageable now... having brain fog less often and feeling more in control, I am able to self regulate easier."' },
  { reviewer: 'Julie H. (45-54)', date: '3rd Aug 2025', stars: 5, text: '"I have **** and I was suffering burnout. I wasn\'t eating well and my sleep was poor. I was recommended get dopa by a nutritionist as a good quality supplement that would help me get my body back into balance. I\'m on my third month now and feel ten times better already."' },
  { reviewer: 'Sabrina P. (25-34)', date: '17th Apr 2025', stars: 5, text: '"I\'ve struggled for a long time with keeping my brain focussed. get dopa has been a game changer. For the first time I\'ve felt like my mind was calmer and quieter, and given me the break I needed to take the next steps to keeping my **** in check."' }
],
        accordion: {
          matchHeading: "what to expect",
          newHeading:   'your variant 2 accordion heading',
          newContent:   '<p>Your variant 2 accordion content goes here.</p>'
        },
        // Slot indices are gallery positions and are identical for every variant —
        // only the URLs change. The two pages number their slides differently, so
        // each role carries its own index and URL per page. Leave a src empty to
        // let that page keep its theme image.
        images: {
          socialProof: {
            alt:     '',
            product: { slide: 1, src: '' },
            landing: { slide: 0, src: '' }
          },
          statement: {
            alt:     '',
            product: { slide: 2, src: '' },
            landing: { slide: 1, src: '' }
          },
          after: {
            alt:     '',
            product: { slide: 6, src: '' },
            landing: { slide: 5, src: '' }
          },
          survey: {
            alt:     '',
            product: { slide: 7, src: '' },
            landing: { slide: 6, src: '' }
          },
          directions: {
            alt:     '',
            product: { slide: 8, src: '' },
            landing: { slide: 3, src: '' }
          },
          moneyBack: {
            alt:     '',
            product: { slide: 9, src: '' },
            landing: { slide: 8, src: '' }
          }
        }
      }
    },

    '3': {
      toggles: {
        heading:      true,
        subheading:   true,
        ratingCaption:true,
        bodyText:     true,
        reviews:      true,
        accordion:    true,
        images: {
          socialProof: false,
          statement:   false,
          after:       false,
          survey:      false,
          directions:  false,
          moneyBack:   false
        }
      },
      copy: {
        heading:       'brain food',
        subheading:    'reclaim your clarity',
        ratingCaption: '4.7 rated by 836 customers',
        text:          'Feel clearer and settle into steadier focus.<br><br>A daily blend of 16 nutrients and botanicals to support clearer thinking and steady energy.',
       reviews: [
  { reviewer: 'Fleur B. (44-54)', date: '1st Sep 2025', stars: 5, text: '"Oh my goodness me - I\'ve been taking get dopa for a few weeks and it\'s made a noticeable difference. During perimenopause I\'d been struggling with brain fog, overwhelm and fluctuating moods. Now I feel calmer, clearer and much more able to get through the day."' },
  { reviewer: 'Louise B. (44-54)', date: '13th Dec 2025', stars: 5, text: '"My menopausal brain refuses to work these days. Get Dopa helps my brain work. I was so sceptical until I came off them for a few weeks and noticed a massive difference — the brain fog came back. They work, they\'re fab."' },
  { reviewer: 'Vicki T. (35-44)', date: '9th May 2025', stars: 5, text: '"My brain fog has lifted and I am just able to function as a human again... I just feel like I\'m not wading through mud anymore."' },
  { reviewer: 'Sarah K. (45-54)', date: '19th Nov 2025', stars: 5, text: '"I\'ve tried so many supplements over the years and get dopa is the one product that actually works for me. Three capsules in the morning and I\'m able to function efficiently — almost as if I don\'t have a busy brain and perimenopause symptoms. I highly recommend."' },
  { reviewer: 'Amy H. (35-44)', date: '5th May 2025', stars: 5, text: '"I noticed an immediate difference from day 1. More clarity, focus and mental calm, without any jitters or feeling wired. I also had knock-on benefits of dramatically reduced PMS struggles like low mood, energy slumps and brain fog — which was a huge win."' }
],
        accordion: {
          matchHeading: "for brains that don’t switch off",
          newHeading:   "when your brain doesn’t feel like yours",
          newContent:   '<p>There are times when your brain just doesn\'t feel like yours — more overwhelm, harder to focus, harder to stay on top of things.</p><p>get dopa is a daily blend of 16 nutrients and botanicals to support focus, energy and mental clarity — all in one easy morning supplement.</p><p>Read what our customers say and see how get dopa fits into your day.</p>'
        },
        // Slot indices are gallery positions and are identical for every variant —
        // only the URLs change. The two pages number their slides differently, so
        // each role carries its own index and URL per page. Leave a src empty to
        // let that page keep its theme image.
        images: {
          socialProof: {
            alt:     '',
            product: { slide: 1, src: '' },
            landing: { slide: 0, src: '' }
          },
          statement: {
            alt:     '',
            product: { slide: 2, src: '' },
            landing: { slide: 1, src: '' }
          },
          after: {
            alt:     '',
            product: { slide: 6, src: '' },
            landing: { slide: 5, src: '' }
          },
          survey: {
            alt:     '',
            product: { slide: 7, src: '' },
            landing: { slide: 6, src: '' }
          },
          directions: {
            alt:     '',
            product: { slide: 8, src: '' },
            landing: { slide: 3, src: '' }
          },
          moneyBack: {
            alt:     '',
            product: { slide: 9, src: '' },
            landing: { slide: 8, src: '' }
          }
        }
      }
    },
      '4': {
      toggles: {
        heading:      true,
        subheading:   true,
        ratingCaption:true,
        bodyText:     true,
        reviews:      true,
        accordion:    true,
        images: {
          socialProof: false,
          statement:   false,
          after:       false,
          survey:      false,
          directions:  false,
          moneyBack:   false
        }
      },
      copy: {
        heading:       'brain food',
        subheading:    'reclaim your balance',
        ratingCaption: '4.7 rated by 836 customers',
        text:          'Feel more balanced and settled throughout the month.<br><br>A daily blend of 16 nutrients and botanicals to support mood, focus and steady energy.',
 reviews: [
      { reviewer: 'Emma L. (25-34)',  date: '4th Aug 2025',    stars: 5, text: '"Nearly two years in and the difference in my mood is undeniable. I feel a lot more balanced and less \'up and down\'. It helps me stay more in control of my emotions, focus and motivation - and it really helps with my PMDD, which is a massive bonus. Even after a week I felt brighter."' },
      { reviewer: 'Lucy S. (25-34)',   date: '10th Sep 2024',   stars: 5, text: '"Get Dopa has changed my life! I\'ve struggled with PMDD for years and it\'s hugely impacted my life. I saw Get Dopa online and thought okay let\'s try this, I\'m sure it won\'t work but WOW! The change was so fast - 2+ months in and I will not be without this ever again."' },
      { reviewer: 'Amy H. (35-44)',   date: '5th Mar 2025',    stars: 5, text: '"I noticed an immediate difference from day 1. More clarity, focus and mental calm, without any jitters or feeling wired. Dramatically reduced PMS symptoms - low mood, energy slumps and brain fog - which was a huge win."' },
      { reviewer: 'Jodie B. (25-34)', date: '14th Aug 2024',   stars: 5, text: '"For the first time in my adult life I feel able to trust that my mood and energy will be generally consistent (aside from cycle fluctuations), and the payoff has been huge. Finally, I\'ve been able to harness the positives, without suffering the fallout of burnout and crashing energy."' },
      { reviewer: 'Zoe S. (35-44)',  date: '17th Apr 2025',   stars: 5, text: '"I had a 4-day break due to ordering issues, and I noticed I was very unstable - my mood and mind became very erratic. I\'m not sure if this was my hormones or not being on this supplement, but I was happy knowing I had them when they arrived."' }
    ],
        accordion: {
          matchHeading: "for brains that don’t switch off",
          newHeading:   "when your brain doesn’t feel like yours",
          newContent:   '<p>There are times when your brain just doesn\'t feel like yours — harder to focus, harder to stay even, harder to feel like yourself.</p><p>get dopa is a daily blend of 16 nutrients and botanicals to support mood, focus and mental clarity — all in one easy morning supplement.</p><p>Read what our customers say and see how get dopa fits into your day.</p>'
        },
        // Slot indices are gallery positions and are identical for every variant —
        // only the URLs change. The two pages number their slides differently, so
        // each role carries its own index and URL per page. Leave a src empty to
        // let that page keep its theme image.
        images: {
          socialProof: {
            alt:     '',
            product: { slide: 1, src: '' },
            landing: { slide: 0, src: '' }
          },
          statement: {
            alt:     '',
            product: { slide: 2, src: '' },
            landing: { slide: 1, src: '' }
          },
          after: {
            alt:     '',
            product: { slide: 6, src: '' },
            landing: { slide: 5, src: '' }
          },
          survey: {
            alt:     '',
            product: { slide: 7, src: '' },
            landing: { slide: 6, src: '' }
          },
          directions: {
            alt:     '',
            product: { slide: 8, src: '' },
            landing: { slide: 3, src: '' }
          },
          moneyBack: {
            alt:     '',
            product: { slide: 9, src: '' },
            landing: { slide: 8, src: '' }
          }
        }
      }
    },
      '5': {
      toggles: {
        heading:      false,
        subheading:   true,
        ratingCaption:true,
        bodyText:     true,
        reviews:      true,
        accordion:    true,
        images: {
          socialProof: true,
          statement:   true,
          after:       true,
          survey:      true,
          directions:  true,
          moneyBack:   true
        }
      },
      copy: {
        heading:       '',
        subheading:    'less fog. more clarity',
        ratingCaption: '4.7 rated by 836 customers',
        text:          'Feel sharper and think clearly again.<br><br>A daily blend of 16 nutrients and botanicals to support mental clarity, focus and energy.',
        reviews: [
          { reviewer: 'Joanna F. (35–44)', date: '21st Sep 2025', stars: 5, text: '"It\'s like a fog has lifted—my mind feels clearer, and I can finally focus on what needs to get done without getting overwhelmed. It\'s made a real difference in my productivity and daily life. I\'ve tried a lot of different supplements in the past, but get dopa is the only one that\'s worked."' },
          { reviewer: 'Lucy R. (25–34)', date: '17th Apr 2025', stars: 5, text: '"Brain fog gone. Feel more can and can concentrate more and for longer"' },
          { reviewer: 'Cavan P. (35–44)', date: '27th Nov 2024', stars: 5, text: '"I am 4 weeks in and have noticed an improvement in my stress levels and brain fog has greatly improved. I have also noticed my mood is better and also my digestion. Would highly recommend"' },
          { reviewer: 'Samara L. (35–44)', date: '1st Jan 2025', stars: 5, text: '"I\'ve taken plenty of supplements before but haven\'t ever experienced these gains. I can think without brain fog, have focus and motivation, my mood is much more stable and higher all over. I find myself thinking (Is this what a "normal" person would feel)"' },
          { reviewer: 'Jordan N. (35–44)', date: '24th Apr 2025', stars: 5, text: '"I was a little dubious at first but thought I\'d give it a try. I\'ve been taking get Dopa for about 3 weeks and the biggest change I have noticed is the clarity I have in my mind. I always felt like I had "brain fog" before and this product seems to have lifted that."' }
        ],
        accordion: {
          matchHeading: "for brains that don’t switch off",
          newHeading:   "when everything feels a bit foggy",
          newContent:   '<p>There are times when your thinking just feels slower — harder to concentrate, harder to stay sharp, harder to keep up with your own to-do list.</p><p>get dopa is a daily blend of 16 nutrients and botanicals to support focus, mental clarity and energy — all in one easy morning supplement.</p><p>Read what our customers say and see how get dopa fits into your day.</p>'
        },
        // Slot indices are gallery positions and are identical for every variant —
        // only the URLs change. The two pages number their slides differently, so
        // each role carries its own index and URL per page. Leave a src empty to
        // let that page keep its theme image.
        images: {
          socialProof: {
            alt:     'Trusted by thousands of busy brains — 4.7 star rating from 800+ reviews',
            product: { slide: 1, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Product_Page_Image_Social-Proof_sp5.webp?v=1787069007' },
            landing: { slide: 0, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Landing_Page_Image_Social-Proof_sp5_v2.webp?v=1787243206' }
          },
          statement: {
            alt:     'When your head won\'t clear — slow starts, feeling scattered, losing your train of thought',
            product: { slide: 2, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Product_Page_Image_statement_sp5.webp?v=1787069005' },
            landing: { slide: 1, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Landing_Page_Image_statement_sp5.webp?v=1787069006' }
          },
          after: {
            alt:     'Before and after: from foggy and struggling to find the words, to clear-headed and sharp again',
            product: { slide: 6, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Product_page_after_sp5.webp?v=1787069005' },
            landing: { slide: 5, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Landingpageafter_sp5.webp?v=1787069005' }
          },
          survey: {
            alt:     'Felt clearer, felt by you — 63% felt calmer and less foggy, 69% found it easier to get started, 72% noticed a difference in four weeks',
            product: { slide: 7, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Product_Page_Image_Survey_sp5.webp?v=1787069006' },
            landing: { slide: 6, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Landing_Page_Image_Survey_sp5.webp?v=1787069006' }
          },
          directions: {
            alt:     'Take 3 capsules once a day to feel clear and focused — pouch contains 90 capsules for 30 days',
            product: { slide: 8, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Product_Page_Image_directions_sp5.webp?v=1787069007' },
            landing: { slide: 3, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Landing_Page_Image_directions_sp5.webp?v=1787069006' }
          },
          moneyBack: {
            alt:     '60-day money-back guarantee — try get dopa risk-free',
            product: { slide: 9, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Product_Page_Image_money-back_sp5.webp?v=1787069006' },
            landing: { slide: 8, src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Landing_Page_Image_money-back_sp5_v2.webp?v=1787243206' }
          }
        }
      }
    }
  };

  // ─────────────────────────────────────────────────────────────
  // HELPERS
  // ─────────────────────────────────────────────────────────────
  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function getCookie(name) {
    var escapedName = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setStoredValue(value) {
    try { localStorage.setItem(storageKey, value); } catch (e) {}
    setCookie(storageKey, value, cookieDays);
  }

  function getStoredValue() {
    try {
      var localValue = localStorage.getItem(storageKey);
      if (localValue) return localValue;
    } catch (e) {}
    return getCookie(storageKey);
  }

  function getParamValue(param) {
    return new URL(window.location.href).searchParams.get(param);
  }

  // ── PAGE CONTEXT ───────────────────────────────────────────
  // The script runs on two templates whose galleries are different shapes, so
  // each image slot carries one URL per template. '/products/…' (including the
  // localised '/en-au/products/…' market prefixes) is the Shopify product
  // template; everything else is a landing-page PDP.
  function getPageContext() {
    return window.location.pathname.indexOf('/products/') !== -1 ? 'product' : 'landing';
  }

  // Frame is 130/75 on the product page, 1.45/1 on the landing PDP. Both crop
  // with object-fit: cover, so supply each page the size it was cut for.
  var contextProfiles = {
    product: { w: 2000, h: 1157, widths: [440, 580, 740, 1000, 1200, 1400, 1600, 2000] },
    landing: { w: 1424, h: 966,  widths: [390, 580, 740, 900, 1068, 1424] }
  };

  // Matches the sizes attribute both galleries render via pdp-gallery-image.liquid.
  var gallerySizes = '(min-width: 1700px) 712px, (min-width: 750px) calc(50vw - 27px), 100vw';

  function cdnWidth(src, width) {
    if (!src || src.indexOf('cdn.shopify.com') === -1) return src; // non-Shopify asset: leave alone
    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function swapImage(selector, newSrc, alt, context, isThumb) {
    if (!newSrc) return false;

    // Owl runs the product gallery with loop: true, which prepends clones of
    // the last slides and appends clones of the first. One slot index can
    // therefore match several elements, and document.querySelector returns
    // whichever comes first in document order — usually a prepended clone,
    // leaving the real slide showing its theme image. Swap every match.
    var containers = document.querySelectorAll(selector);
    if (!containers.length) return false;

    var profile = contextProfiles[context];
    var swapped = false;

    Array.prototype.forEach.call(containers, function (container) {
      var img = container.querySelector('img');
      if (!img) return;

      // Drop the Liquid-rendered candidates before writing ours, otherwise the
      // old srcset can still win the selection.
      img.removeAttribute('srcset');

      if (isThumb) {
        // Thumbnails render in a 130px box; 320 covers 2x without pulling the
        // full-size slide file down three times over.
        img.src = cdnWidth(newSrc, 320);
        img.removeAttribute('sizes');
      } else {
        img.src    = cdnWidth(newSrc, profile.w);
        img.srcset = profile.widths
          .map(function (width) {
            return cdnWidth(newSrc, width) + ' ' + width + 'w';
          })
          .join(', ');
        img.sizes  = gallerySizes;
        img.width  = profile.w;
        img.height = profile.h;
      }

      if (alt) img.alt = alt;
      swapped = true;
    });

    return swapped;
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getPersonaCustomerProofEl() {
    return document.querySelector('[data-persona-customer-proof]');
  }

  function getTrustpilotLogoUrl() {
    var el = getPersonaCustomerProofEl();
    return el && el.dataset ? el.dataset.trustpilotLogoUrl || '' : '';
  }

  function getReviewsIoLogoUrl() {
    var el = getPersonaCustomerProofEl();
    return el && el.dataset ? el.dataset.reviewsIoLogoUrl || '' : '';
  }

  function trustpilotBadgeHtml() {
    var url = getTrustpilotLogoUrl();
    if (!url) return '';
    return (
      '<div class="campaign-pdp-customer-proof__platform-svg campaign-pdp-customer-proof__platform-svg--trustpilot" aria-hidden="true">' +
      '<img class="campaign-pdp-customer-proof__platform-img" src="' +
      escapeHtml(url) +
      '" width="112" alt="" loading="lazy" style="width:112px;height:auto;max-height:112px;object-fit:contain">' +
      '</div>'
    );
  }

  function reviewsIoBadgeHtml() {
    var url = getReviewsIoLogoUrl();
    if (!url) return '';
    return (
      '<div class="campaign-pdp-customer-proof__platform-svg campaign-pdp-customer-proof__platform-svg--reviews-io" aria-hidden="true">' +
      '<img class="campaign-pdp-customer-proof__platform-img" src="' +
      escapeHtml(url) +
      '" width="112" height="20" alt="" loading="lazy">' +
      '</div>'
    );
  }

  // ─────────────────────────────────────────────────────────────
  // APPLY
  // ─────────────────────────────────────────────────────────────
  function applyPersona() {
    var activeValue = getStoredValue();

    if (!activeValue || !variants[activeValue]) return false;

    var cfg     = variants[activeValue];
    var toggles = cfg.toggles;
    var copy    = cfg.copy;
    var applied = false;

    if (toggles.heading) {
      document.querySelectorAll('[data-dx-heading]').forEach(function (el) {
        el.textContent = copy.heading;
        applied = true;
      });
    }

    if (toggles.subheading) {
      document.querySelectorAll('[data-dx-subheading]').forEach(function (el) {
        el.textContent = copy.subheading;
        applied = true;
      });
    }

    if (toggles.ratingCaption) {
      document.querySelectorAll('.rating-text-caption').forEach(function (el) {
        el.textContent = copy.ratingCaption;
        applied = true;
      });
    }

    if (toggles.bodyText) {
      document.querySelectorAll('[data-dx-text]').forEach(function (el) {
        el.innerHTML = '<p>' + copy.text + '</p>';
        applied = true;
      });
    }

    if (toggles.accordion && copy.accordion) {
      document.querySelectorAll('.product__accordion').forEach(function (accordion) {
        var headingEl = accordion.querySelector('.collapsible_tab__title');
        var contentEl = accordion.querySelector('.accordion__content');
        if (!headingEl || !contentEl) return;
        if (headingEl.textContent.trim().toLowerCase() === copy.accordion.matchHeading.toLowerCase()) {
          headingEl.textContent = copy.accordion.newHeading;
          contentEl.innerHTML   = copy.accordion.newContent;
          applied = true;
        }
      });
    }

    // ── REVIEWS ────────────────────────────────────────────────
    var existingCard = document.querySelector(
      '[data-dx-reviews]:not([data-persona-customer-proof]) .custom-reviews-carousel__card'
    );
    var starTemplate = existingCard
      ? existingCard.querySelector('.custom-reviews-carousel__stars').innerHTML
      : '';
    var arrowTemplate = existingCard
      ? existingCard.querySelector('.pdp-trust-review-card__next').innerHTML
      : '';

    var tickTemplate = '';
    if (existingCard) {
      var reviewerDiv = existingCard.querySelector('.pdp-trust-review-card__reviewer');
      if (reviewerDiv) {
        var clone = reviewerDiv.cloneNode(true);
        var nameSpan = clone.querySelector('span');
        if (nameSpan) clone.removeChild(nameSpan);
        tickTemplate = clone.innerHTML.trim();
      }
    }

    var proofStarsEl = document.querySelector(
      '[data-persona-customer-proof] .campaign-pdp-customer-proof__stars'
    );
    var proofStarTemplate = proofStarsEl ? proofStarsEl.innerHTML : '';

    function buildStars() {
      return '<div class="custom-reviews-carousel__stars">' + starTemplate + '</div>';
    }

    function buildCard(review) {
      return (
        '<div class="custom-reviews-carousel__card">' +
        '<div class="pdp-trust-review-card__top">' +
        '<div class="pdp-trust-review-card__reviewer">' +
        '<span>' +
        review.reviewer +
        '</span>' +
        tickTemplate +
        '</div>' +
        '<div class="pdp-trust-review-card__date">' +
        review.date +
        '</div>' +
        '</div>' +
        '<div class="custom-reviews-carousel__review">' +
        '<p class="custom-reviews-carousel__review-text">' +
        review.text +
        '</p>' +
        '</div>' +
        '<div class="pdp-trust-review-card__footer">' +
        buildStars() +
        '<button type="button" class="pdp-trust-review-card__next" aria-label="Next review">' +
        arrowTemplate +
        '</button>' +
        '</div>' +
        '</div>'
      );
    }

    function buildCampaignCustomerProofCard(review, starsInner) {
      var headline = review.headline != null ? String(review.headline) : '';
      var body =
        review.body != null && String(review.body) !== ''
          ? String(review.body)
          : String(review.text || '');
      var author = escapeHtml(review.reviewer || '');
      var platform = review.platform || 'reviews_io';
      var platformHtml = '';
      if (platform === 'trustpilot') {
        var tp = trustpilotBadgeHtml();
        if (tp) {
          platformHtml =
            '<div class="campaign-pdp-customer-proof__platform-badge">' + tp + '</div>';
        }
      } else if (platform === 'reviews_io') {
        var rio = reviewsIoBadgeHtml();
        if (rio) {
          platformHtml =
            '<div class="campaign-pdp-customer-proof__platform-badge">' + rio + '</div>';
        }
      }
      var photoBlock = '';
      if (review.photo) {
        photoBlock =
          '<div class="campaign-pdp-customer-proof__photo-wrap"><img class="campaign-pdp-customer-proof__photo" src="' +
          escapeHtml(review.photo) +
          '" alt="" loading="lazy" width="250" height="250"></div>';
      }
      var starsBlock =
        '<div class="campaign-pdp-customer-proof__stars">' +
        (starsInner || '') +
        '</div>';
      return (
        '<div class="campaign-pdp-customer-proof__slide">' +
        '<article class="campaign-pdp-customer-proof__card">' +
        photoBlock +
        '<div class="campaign-pdp-customer-proof__quotes">' +
        (headline
          ? '<p class="campaign-pdp-customer-proof__headline">' + escapeHtml(headline) + '</p>'
          : '') +
        (body
          ? '<p class="campaign-pdp-customer-proof__body">' + escapeHtml(body) + '</p>'
          : '') +
        '</div>' +
        starsBlock +
        '<div class="campaign-pdp-customer-proof__meta">' +
        (author ? '<p class="campaign-pdp-customer-proof__author">' + author + '</p>' : '') +
        platformHtml +
        '</div>' +
        '</article>' +
        '</div>'
      );
    }
    

    if (toggles.reviews && copy.reviews && copy.reviews.length) {
      // Only replace reviews in the top smaller carousel.
      // Skip the bottom customer-proof carousel so its photos and layout stay intact.
      document
        .querySelectorAll('[data-dx-reviews]:not([data-persona-customer-proof])')
        .forEach(function (carousel) {
          var owl = carousel.querySelector('.owl-carousel');
          if (!owl) return;
          if (owl.classList.contains('owl-loaded') && typeof jQuery !== 'undefined') {
            jQuery(owl).trigger('destroy.owl.carousel');
            owl.classList.remove('owl-loaded');
          }
          owl.innerHTML = copy.reviews.map(buildCard).join('');
          try {
            owl.dispatchEvent(new CustomEvent('dx-persona-reviews-injected', { bubbles: true }));
          } catch (e3) {}
          applied = true;
        });
    }

    // ── IMAGES ─────────────────────────────────────────────────
    // Images are keyed by role, not by slide number, because the two templates
    // number their galleries differently: on the product page slide 0 is the
    // custom.pdp_image metafield and product media follow, while on the landing
    // PDP the gallery blocks are numbered from 0. Each role therefore names its
    // own slide index and URL per page. A role with an empty src for the current
    // page is skipped, so that page keeps its theme image.
    var context      = getPageContext();
    var imageSet     = copy.images || {};
    var imageToggles = toggles.images || {};

    Object.keys(imageSet).forEach(function (roleKey) {
      if (!imageToggles[roleKey]) return;

      var entry  = imageSet[roleKey];
      var target = entry && entry[context];
      if (!target || !target.src) return;
      if (target.slide === undefined || target.slide === null || target.slide === '') return;

      if (swapImage('[data-dx-slide="' + target.slide + '"]', target.src, entry.alt, context, false)) {
        applied = true;
      }
      // The thumbnail shares its slide's index. Reuse the slide art unless the
      // role supplies a dedicated crop, otherwise the strip would still show
      // the theme image next to a personalised slide.
      var thumbSrc = target.thumbSrc || target.src;
      if (swapImage('[data-dx-thumb="' + target.slide + '"]', thumbSrc, entry.alt, context, true)) {
        applied = true;
      }
    });

    document.documentElement.setAttribute('data-dx', activeValue);
    document.documentElement.setAttribute('data-dx-context', context);
    if (applied) document.documentElement.classList.add(readyClass);

    return applied;
  }

  function runPersona() {
    var applied = false;

    // A throw in here must not leave the personalised elements — the PDP hero
    // among them — waiting on a dx-ready class that would now never be set.
    try {
      applied = applyPersona();
    } catch (e) {
      applied = false;
    }

    if (!applied && retries < maxRetries) {
      retries++;
      setTimeout(runPersona, 150);
      return;
    }

    // Out of retries, or there was nothing on this page to swap. Reveal anyway:
    // holding the hidden state any longer only costs the visitor the hero image.
    if (!applied) document.documentElement.classList.add(readyClass);
  }

  // ─────────────────────────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────────────────────────
  var paramValue = getParamValue(urlParam);

  if (paramValue && validValues.indexOf(paramValue) !== -1) {
    setStoredValue(paramValue);
    document.documentElement.classList.add('dx-active');
  }

  if (validValues.indexOf(getStoredValue()) !== -1) {
    document.documentElement.classList.add('dx-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runPersona);
  } else {
    runPersona();
  }
})();